export default "__VITE_ASSET__edc5e55d__"